<template>
  <div class="main">
    <c-panel>
      <form-programa :paramId="$route.params.id" v-on:onSubmitPrograma="onSubmitPrograma"></form-programa>
    </c-panel>
  </div>
</template>
<script>
import formPrograma from "./form"

export default {
  methods: {
    onSubmitPrograma () {
      this.$router.push('/admin/financeiro/programa')
    }
  },
  components: { formPrograma }
}
</script>

